var React = require('react');

function FacebookWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook Icon White"),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 9.0625C0 4.05742 4.05742 0 9.0625 0H48.9375C53.9426 0 58 4.05742 58 9.0625V48.9375C58 53.9426 53.9426 58 48.9375 58H9.0625C4.05742 58 0 53.9426 0 48.9375V9.0625ZM29 14.5C36.975 14.5 43.5 21.025 43.5 29C43.5 36.25 38.2438 42.4125 30.9938 43.5V33.1687H34.4375L35.1625 29H31.175V26.2812C31.175 25.1937 31.7188 24.1063 33.5312 24.1063H35.3438V20.4813C35.3438 20.4813 33.7125 20.1188 32.0813 20.1188C28.8188 20.1188 26.6437 22.1125 26.6437 25.7375V29H23.0187V33.1687H26.6437V43.3187C19.7562 42.2312 14.5 36.25 14.5 29C14.5 21.025 21.025 14.5 29 14.5Z","fill":"white","key":1})]);
}

FacebookWhite.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none","className":"icon_wrap"};

module.exports = FacebookWhite;

FacebookWhite.default = FacebookWhite;
